import { render, staticRenderFns } from "./PurchaseOrderDataWidget.vue?vue&type=template&id=7703e5ba&"
import script from "./PurchaseOrderDataWidget.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderDataWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports